import { useEffect } from "react";
// @mui
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
// hooks
import { useResponsive } from "src/hooks/use-responsive";
// hooks
import { useUser } from "src/auth/hooks";
import { NavSectionVertical } from "src/components/nav-section";
import Scrollbar from "src/components/scrollbar";
import { usePathname } from "src/routes/hooks";
//
import { Link } from "@mui/material";
import { LogoSlim } from "src/components/logo/slim";
import { RouterLink } from "src/routes/components";
import { NavToggleButton } from "../_common";
import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const user = useUser();

  const pathname = usePathname();

  const lgUp = useResponsive("up", "lg");

  const navData = useNavData();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Link component={RouterLink} href="/">
        <Box sx={{ mt: 3, mb: 1 }}>
          <LogoSlim isCollapsed={false} />
        </Box>
      </Link>

      <NavSectionVertical
        data={navData}
        config={{
          currentRole: "",
        }}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: "fixed",
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
